export var StorageTimeType;
(function (StorageTimeType) {
    StorageTimeType[StorageTimeType["SixMonths"] = 0] = "SixMonths";
})(StorageTimeType || (StorageTimeType = {}));
